import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '@lemon8/design';
import { ButtonSize } from '@lemon8/design/src/components/Button/button';
import { useAtomValue } from 'jotai';
import { getCookieChoice, setCookieChoice } from './utils';
import { EURO_COUNTRY_LIST } from '@lemon8/web-app-shared/i18n';
import { $Locale, $USPreBanState, $UserAgent } from '@lemon8/web-app-shared/atom';

import './style.scss';

const CookieBanner = () => {
  const { isMobile } = useAtomValue($UserAgent);
  const hitUSBan = useAtomValue($USPreBanState);
  const { region, ipRegion } = useAtomValue($Locale);
  const isStrictRegion = EURO_COUNTRY_LIST.includes(ipRegion) || EURO_COUNTRY_LIST.includes(region);

  // SSR 进入cookie setting需要直接设置banner初始不展示
  const bannerTitle = 'Accept cookies from Lemon8 on this browser?';
  const bannerContent = [
    'We use cookies and similar technologies to deliver, maintain and improve our services; improve your experience on our websites; and ensure the security, performance and stability of the website. By clicking "Learn More", you can find our Cookies Policy which describes how we use cookies and similar technologies.',
  ];
  // 初值先给false，否则用户选择后，SSR首刷还是会走render，闪一下
  const [bannerVisible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    // 每次先判断用户是否已有cookie选择，已有则不展示banner
    const cookieChoices = getCookieChoice();
    // 首次进入判断是否需要加载相关SDK, 本次英国均为essential cookie，不需要cookie setting，先注释
    // const cookieChoices = handleCookieChoiceInStrictRegion(isStrictRegion);
    // 用户已经做过选择，不展示banner
    if (JSON.stringify(cookieChoices) !== '{}') {
      setVisible(false);
    } else if (isStrictRegion) {
      // 初值false，useEffect中严格国家未同意时修改为true
      setVisible(true);
      window.Tea('wap_cookies_show');
    }
  }, []);

  const onAcceptAllClick = useCallback(() => {
    // 记录用户选择到Cookie中
    setCookieChoice({ teasdk: true });
    setVisible(false);
    window.Tea('wap_cookies_click', {
      click_result: 'ok',
    });
  }, []);

  const handleBannerToPrivacy = useCallback(() => {
    window.Tea('wap_cookies_click', {
      click_result: 'learn_more',
    });
    window.open(`/legal/cookies-policy?region=${region.toLowerCase()}`);
  }, [region]);

  if (hitUSBan) {
    return null;
  }

  return (
    <>
      {bannerVisible && (
        <div className={'wap-cookie-policy-banner'}>
          <div className="wap-cookie-policy-content">
            <h3 className="wap-cookie-policy-title">{bannerTitle}</h3>
            <div className="wap-cookie-policy-text">
              {bannerContent.map((item, index) => {
                return <p key={index}>{item}</p>;
              })}
            </div>
          </div>
          <div className="wap-cookie-policy-btn-group">
            <Button
              className="wap-cookie-policy-btn"
              title={'Learn More'}
              onClick={handleBannerToPrivacy}
              variant={'Secondary'}
              size={ButtonSize.large}
            />
            <Button
              className="wap-cookie-policy-btn"
              title={'OK'}
              onClick={onAcceptAllClick}
              variant={'Secondary'}
              size={ButtonSize.large}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CookieBanner;
